import { z } from 'zod';

export const ErrorModel = z.object({
  code: z.string().optional(),
  description: z.string().optional(),
});
